import { Controller } from "@hotwired/stimulus";

// 業績報告用データの表で、値の横のアイコンボタンから数値だけをクリップボードにコピーする（Excel のセルに貼りやすくするため）。
// 画面の表示が「¥1,127,310,000」でも、コピーするのは text value の「1127310000」。
// 結果はアイコン（成功は緑のチェック、失敗は赤のバツ）と、ボタンの title / aria-label で知らせる。
// admin/data_analysis/performance_reports/show.html.erb から使う。
export class CopyValueController extends Controller {
  static targets = ["button", "icon"];
  static values = { text: String, copiedLabel: String, failedLabel: String };

  connect() {
    this.defaultIconClass = this.iconTarget.className;
    this.defaultLabel = this.buttonTarget.title;
  }

  disconnect() {
    clearTimeout(this.resetTimer);
  }

  async copy() {
    clearTimeout(this.resetTimer);
    try {
      await navigator.clipboard.writeText(this.textValue);
      this.showResult("fas fa-check text-success", this.copiedLabelValue);
    } catch (_e) {
      // コピーできたと思い込んで古い値を貼らないよう、失敗したことを画面に出す。
      this.showResult("fas fa-times text-danger", this.failedLabelValue);
    }
    this.resetTimer = setTimeout(() => { this.showResult(this.defaultIconClass, this.defaultLabel); }, 1500);
  }

  // アイコンとボタンの説明を差し替える。
  showResult(iconClass, label) {
    this.iconTarget.className = iconClass;
    this.buttonTarget.title = label;
    this.buttonTarget.setAttribute("aria-label", label);
  }
}
